import React, { Fragment, memo } from 'react'
import PropTypes from 'prop-types'

import { Dropdown, FormGroup, FormLabel } from '../../../../../../../components'

import { getGAValue, isShowNailer } from '../../../../../common/fns'
import { RenderAorB, RenderIf, isOneDropdownOption } from '../../../../../../../utils/fns'

const CommonSelector = (props) => {
  const {
    label,
    type,
    material,
    width,
    depth,
    thickness,
    onChange,
    optionsData,
    onChangeLumberSpecies,
  } = props

  return (
    <Fragment>
      <FormGroup>
        <FormLabel htmlFor={`${label}.material`}>Lumber Species</FormLabel>
        <Dropdown
          name={`${label}.material`}
          value={material}
          options={optionsData.materialOptions}
          onChange={onChangeLumberSpecies || onChange}
          disabled={isOneDropdownOption(optionsData.materialOptions)}
          data-ga4={`${label}_lumberSpecies:${getGAValue(optionsData.materialOptions, material)}`}
          data-testid={`${label}.material`}
        />
      </FormGroup>

      {RenderAorB(
        isShowNailer(type),
        <FormGroup>
          <FormLabel htmlFor={`${label}.width`}>Thickness</FormLabel>
          <Dropdown
            name={`${label}.width`}
            value={width}
            options={optionsData.widthOptions}
            onChange={onChange}
            disabled={isOneDropdownOption(optionsData.widthOptions)}
            data-ga4={`${label}_thickness:${getGAValue(optionsData.widthOptions, width)}`}
            data-testid={`${label}.thickness`}
          />
        </FormGroup>,
        <FormGroup>
          <FormLabel htmlFor={`${label}.width`}>Width</FormLabel>
          <Dropdown
            name={`${label}.width`}
            value={width}
            options={optionsData.widthOptions}
            onChange={onChange}
            disabled={isOneDropdownOption(optionsData.widthOptions)}
            data-ga4={`${label}_width:${getGAValue(optionsData.widthOptions, width)}`}
            data-testid={`${label}.width`}
          />
        </FormGroup>,
      )}

      {RenderAorB(
        isShowNailer(type),
        <FormGroup>
          <FormLabel htmlFor={`${label}.depth`}>Width</FormLabel>
          <Dropdown
            name={`${label}.depth`}
            value={depth}
            options={optionsData.depthOptions}
            onChange={onChange}
            disabled={isOneDropdownOption(optionsData.depthOptions)}
            data-ga4={`${label}_width:${getGAValue(optionsData.depthOptions, depth)}`}
            data-testid={`${label}.width`}
          />
        </FormGroup>,
        <FormGroup>
          <FormLabel htmlFor={`${label}.depth`}>Depth</FormLabel>
          <Dropdown
            name={`${label}.depth`}
            value={depth}
            options={optionsData.depthOptions}
            onChange={onChange}
            disabled={isOneDropdownOption(optionsData.depthOptions)}
            data-ga4={`${label}_depth:${getGAValue(optionsData.depthOptions, depth)}`}
            data-testid={`${label}.depth`}
          />
        </FormGroup>,
      )}

      {RenderIf(
        type === 'ijoist',
        <FormGroup label="Flange Thickness">
          <FormLabel htmlFor={`${label}.thickness`}>Flange Thickness</FormLabel>
          <Dropdown
            name={`${label}.thickness`}
            value={thickness}
            options={optionsData.thicknessOptions}
            onChange={onChange}
            disabled={isOneDropdownOption(optionsData.thicknessOptions)}
            data-ga4={`${label}_thickness:${getGAValue(optionsData.thicknessOptions, thickness)}`}
            data-testid={`${label}.thickness`}
          />
        </FormGroup>,
      )}
    </Fragment>
  )
}

CommonSelector.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  material: PropTypes.number.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  depth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  thickness: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onChangeLumberSpecies: PropTypes.func,
  optionsData: PropTypes.shape({
    materialOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
    widthOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
    depthOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
    thicknessOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  }),
}

export default memo(CommonSelector)
